module.exports = __webpack_public_path__ + "img/02.a80f1839.jpg";